<template>
  <div class="pre-lander" />
</template>

<script>

/**
 * Vue: Pre-Lander (pre-lander)
 * -----------------------------------------------------------------------------
 * Pre-Lander that shows for specific traffic sources.
 * - Limited interactivity section.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'PreLander',

  mounted() {
    this.checkTraffic()
  },

  methods: {

    /**
     * Hide's the spacer above PDP.
     */
    hideSpacer() {
      const spacer = document.querySelector('.site-header-offset')

      spacer.style.display = 'none'
    },

    /**
     * Checks wheather or not traffic source should see the banner.
     */
    checkTraffic() {
      const component = document.querySelector('.pre-lander')
      if (!component) return

      const paramsString = component.getAttribute('data-url-params')
      if (!paramsString) return

      const paramsArray = paramsString.split(',').map(param => param.trim())
      const searchParams = new URLSearchParams(window.location.search)
      const queryValues = Array.from(searchParams.values())

      for (const param of paramsArray) {
        if (queryValues.includes(param)) {
          component.classList.remove('pre-lander__hide')
          component.style.display = 'block';
          this.hideSpacer?.()
          break;
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import './pre-lander';
</style>
